import { StatisticsFormat } from "./constants";

export function getNumberSeparator(numberFormat: StatisticsFormat) {
  if (numberFormat === StatisticsFormat.Comma) return ",";
  if (numberFormat === StatisticsFormat.Dot) return ".";
  if (numberFormat === StatisticsFormat.Space) return " ";
  return "";
}
